import React, { FC } from 'react';
import Card from 'react-bootstrap/Card';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { GameVersionForm } from './gameVersionForm';


interface PropsType {
    gameVersion: IGameVersion;
    updateCallbackTrigger: (clearActiveGameVersion?: boolean) => void;
}


export const GameVersionCard: FC<PropsType> = (props) => {

    return (
        <Card key={props.gameVersion.id} className="m3Card">
            <Card.Body className="cardBody">
                <GameVersionForm gameVersion={props.gameVersion}
                                 updateCallbackTrigger={props.updateCallbackTrigger} />
            </Card.Body>
        </Card>
    );
};
